import { Http } from 'lib'
import IUserData from 'types/sign-in/IUserData'
import apiUrlsAddresses from '../../config/constants/api-urls-addresses'
import ServiceProviderBase from 'lib/ServiceProviderBase'

import { setIsVerifyingEmail, setIsVerified, reset, RegisterEmailVerificationAction } from './store/Actions'

import { RegisterEmailVerificationState, registerEmailVerificationInitialState } from './store/State'

import registerEmailVerificationReducer from './store/Reducer'

export class RegisterEmailVerificationService extends ServiceProviderBase<
  RegisterEmailVerificationState,
  RegisterEmailVerificationAction
> {
  constructor() {
    super(registerEmailVerificationInitialState)
  }

  reduce(
    state: RegisterEmailVerificationState,
    action: RegisterEmailVerificationAction
  ): RegisterEmailVerificationState {
    return registerEmailVerificationReducer(state, action)
  }

  async registerEmailVerification(email: string, token: string): Promise<[IUserData | null, string]> {
    this.dispatch(setIsVerifyingEmail(true))

    const [data, , error] = await Http.post<{ email: string; token: string }, IUserData>(
      apiUrlsAddresses.account.emailVerification.verifyEmail(),
      { email, token }
    )

    this.dispatch(setIsVerifyingEmail(false))
    this.dispatch(setIsVerified(true))

    return error ? [null, error] : [data, null]
  }

  reset() {
    this.dispatch(reset())
  }
}

let instance: RegisterEmailVerificationService = null

export default (() => {
  if (!instance) {
    instance = new RegisterEmailVerificationService()
  }
  return instance
})()
